import { requester } from '../utils';

export const getMoreCafeComments = (cafeId, data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/comment/cafe/${cafeId}`,
        method: 'POST',
        withAuth: false,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log("get more cafe's comment error", err);
        reject(err);
      });
  });
};

export const getMyComments = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/comment/me`,
        method: 'POST',
        withAuth: true,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('get my comments error', err);
        reject(err);
      });
  });
};

export const postNewComment = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/comment`,
        method: 'POST',
        withAuth: true,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('post new comment error', err);
        reject(err);
      });
  });
};

export const getCafeSuitableForList = withAuth => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/comment/cafe-suitable-for`,
        method: 'GET',
        withAuth: withAuth,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('get cafe suitable list error', err);
        reject(err);
      });
  });
};
